

const FetcherResponse={
    name:"response",
    type:"Object",
    props:[
        {
            name:"protocol",
            type:"String",
            description:"always an empty string on ios",
        },
        {name:"code",type:"number"},
        {
            name:"message",
            type:"string",
            description:"Internal error message if any",
        },
        {
            name:"url",
            type:"string",
            description:"Same value as the url property",
        },
        {
            name:"isSuccessful",
            type:"boolean",//@The request/response cycle has finished successfully, but the request is not
            description:`
                Used to verify if the request was actually successful.
                @Sometimes the onProgress is called, isFinished is true but the request is not really successful
                because the server rejected the request.
            `,
        },
        {
            name:"body",
            type:"any",
            description:"the server actual response",
        },
    ],
},onProgress={
    name:"onProgress",
    type:"(data:Object):void",
    props:[{
        name:"data",
        type:"object",
        props:[
            {
                name:"progress",
                type:"number",
                description:`
                    The total progress percentage.
                    @For upload method, the value is not affected by the value of trackEachFile property.
                `,
            },
            {
                name:"isFinished",
                type:"boolean",
                description:`
                    A boolean value that indicates that the server finished dealing with this request.
                    @Please do not used this property to verify that the upload request was successful, use response?.isSuccessful instead
                `,
            },
            FetcherResponse,
        ],
    }],
},onFail={
    name:"onFail",
    type:"(error:Object):void",
    props:[{
        name:"error",
        type:"object",
        props:[
            {name:"message",type:"string"},
            FetcherResponse,
        ],
    }],
},FetcherFile={
    name:"FetcherFile",
    type:"object",
    props:[
        {name:"path",type:"string"},
        {
            name:"key",
            type:"string",
            description:"file key, default to `file${index}`",
        },
        {
            name:"name",
            type:"string",
            description:`
                The uploaded file new name.
                @The string should not include the file extension
                @default to: The file original name
            `,
        },
        {
            name:"type",
            type:"string",
            description:"the file mime type if you wish to specify it otherwise it's determined automatically, default to auto",
        },
    ],
};

export default {
    id:"Fetcher",
    name:"vritra-plugin-fetcher",
    description:`
        uploads/downloads files with progress notification
        @defines a global <b>Fetcher</b> object
    `,
    methods:[
        {
            name:"download",
            type:"(options:Object):void",
            props:[{
                name:"options",
                type:"object",
                props:[
                    {name:"url",type:"string"},
                    {
                        name:"location",
                        type:"string",
                        description:`
                            The location in which should save the file
                            @default:
                            @1) ios: Documents folder
                            @2) android: Download folder
                            @Android:
                            @Location should not be on internal storage, only externals
                        `,
                    },
                    {
                        name:"filename",
                        type:"string",
                        description:`
                            The new downloaded file name without the extension
                            @If a file with this name already exists:
                            @the string " (<random-int>)" is used as a suffix
                            @default to: the app name
                        `,
                    },
                    {
                        name:"type",
                        type:"string",
                        description:"the file mime type, required in some requests",
                    },
                    {
                        name:"toast",
                        type:"string",
                        description:"A string used as a toast message when the file is downloaded",
                    },
                    {
                        name:"overwrite",
                        type:"boolean",
                        description:`
                            If true and a file already exists in the location specified
                            with the given filename property, that file will be replaced
                            @default: false
                        `,
                    },
                    {
                        name:"notify",
                        type:"boolean",
                        description:`
                            if false, no notification is shown to indicate the download progress.
                            @default: true
                        `,
                    },
                    onProgress,onFail,
                ],
            }],
        },
        {
            name:"upload",
            type:"(options:object):void",
            props:[{
                name:"options",
                type:"object",
                props:[
                    {
                        name:"url",
                        type:"string",
                        description:"the target upload url",
                    },
                    {
                        name:"encoding",
                        type:`"form-data"`,
                        description:"only form-data is supported",
                    },
                    {
                        name:"header",
                        type:"object",
                        description:"Headers object",
                    },
                    {
                        name:"body",
                        type:"Object",
                        description:"The form-data fields",
                    },
                    {
                        name:"toast",
                        type:"String",
                        description:"A string to use as a toast message when the upload is successful",
                    },
                    {
                        name:"files",
                        type:"FetcherFile[]",
                        props:[FetcherFile],
                    },
                    {
                        name:"trackEachFile",
                        type:"boolean",
                        description:`
                            If true the upload notification will show the upload progress
                            of each file separately otherwise a single progress for all files
                            @default: false
                        `,
                    },
                    {
                        ...onProgress,
                        props:[
                            ...onProgress.props,
                            {
                                name:"excluded",
                                type:"FetcherFile[]",
                                props:[FetcherFile],
                            },
                        ],
                    },
                    onFail,
                ],
            }],
        },
    ],
}
